import React from "react";
import { Box, Button, Stack } from "@mui/material";
import Modal from "@mui/material/Modal";

interface IUserPermissionProps {
  isModalOpen: boolean;
  title?: string;
  onConfirmedButtonClick: () => void;
  onCancelButtonClick: () => void;
  onCloseModal: () => void;
  titleOne?: string;
  disableSubmitBtn?: boolean;
}

export const UserPermission: React.FC<IUserPermissionProps> = ({
  isModalOpen,
  onConfirmedButtonClick,
  onCancelButtonClick,
  onCloseModal,
  title,
  titleOne,
  disableSubmitBtn,
}) => {
  return (
    <Modal
      open={isModalOpen}
      onClose={onCloseModal}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box className='user-permission-modal-class'>
        <Box className='image-text-wrapper'>
          <Box className='user-permission-heading'>
            {titleOne ? titleOne : ""}
          </Box>
          <Box className='user-permission-title'>{title}</Box>
        </Box>
        <Stack
          className='user-per-button-container'
          direction='row'
          justifyContent='flex-start'
          alignItems='flex-start'
          spacing={2.5}
        >
          <Button
            variant='outlined'
            className='contained-main-app-btn'
            onClick={() => onCancelButtonClick()}
          >
            No
          </Button>
          <Button
            variant='contained'
            className='outlined-main-app-btn'
            disabled={disableSubmitBtn ? disableSubmitBtn : false}
            onClick={() => onConfirmedButtonClick()}
          >
            Yes
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
